import React from 'react';

import { TableCell, TableHeaderCell } from '@hcs/design-system';
import { LineClamp } from '@hcs/design-system';
import { TableCellProps, TableHeaderCellProps } from '@hcs/types';
import {
  PropertyStateArgsProps,
  PropertyStateFieldConfig,
  PropertyStateFields,
  PropertyStatePaths,
  PropertyStateTableCellProps,
  PropertyStateTableHeaderCellProps,
} from '@hcs/types';
import { formatMissing } from '@hcs/utils';

const FIELD = PropertyStateFields.concessionsComments;
type FieldConfig = PropertyStateFieldConfig<typeof FIELD>;
const label = 'Concessions Comments';
const labelShort = 'Conc Cmts';
const propertyStatePath: PropertyStatePaths =
  '/listingDetailsSale/concessions/concessionsComments';

const getValue: FieldConfig['getValue'] = (propertyStateArgs) => {
  const { propertyState, propertyStateType } = propertyStateArgs || {};
  if (propertyStateType === 'flat') {
    return propertyState?.[FIELD];
  } else if (propertyStateType === 'Core') {
    return propertyState?.listingDetailsSale?.concessions?.concessionsComments;
  }
  return undefined;
};

const formatValue: FieldConfig['formatValue'] = (propertyStateArgs) =>
  formatMissing(getValue(propertyStateArgs));

const formatInline: FieldConfig['formatInline'] = (propertyStateArgs) =>
  formatValue(propertyStateArgs);

// eslint-disable-next-line react-refresh/only-export-components
const Display = ({ propertyStateArgs }: PropertyStateArgsProps) => {
  return <>{formatValue(propertyStateArgs)}</>;
};

// eslint-disable-next-line react-refresh/only-export-components
const HeaderCell = (props: PropertyStateTableHeaderCellProps) => {
  return <TableHeaderCell {...props}>{labelShort}</TableHeaderCell>;
};

const defaultHeaderProps: Partial<TableHeaderCellProps> = {
  align: 'right',
  isTableHeaderCell: true,
};

HeaderCell.defaultProps = defaultHeaderProps;

// eslint-disable-next-line react-refresh/only-export-components
const ContentCell = ({
  propertyStateArgs,
  ...tableCellProps
}: PropertyStateTableCellProps) => {
  return (
    <TableCell {...tableCellProps}>
      <LineClamp lines={3} isLargeTooltip renderChildrenAs="tooltipDescription">
        <Display propertyStateArgs={propertyStateArgs} />
      </LineClamp>
    </TableCell>
  );
};

const defaultContentProps: Partial<TableCellProps> = {
  align: 'right',
  isTableCell: true,
};
ContentCell.defaultProps = defaultContentProps;

export const CONCESSIONS_COMMENTS: FieldConfig = {
  field: FIELD,
  label,
  labelShort,
  propertyStatePath,
  getValue,
  formatValue,
  formatInline,
  HeaderCell,
  ContentCell,
  Display,
};
